import { Link, useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BrandLogo, Button } from '@fluent/ui';
import './auth.css';

export function CheckEmail() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';

  return (
    <main className="auth-screen">
      <div className="auth-card">
        <BrandLogo className="auth-card__brand" />
        <span className="auth-card__check-hero" aria-hidden="true">
          <EnvelopeIcon />
        </span>
        <h1 className="auth-card__title">{t('auth.signup.check_email_title')}</h1>
        <p className="auth-card__subtitle">
          {t('auth.signup.check_email_body', { email })}
        </p>
        <Link to="/login" style={{ textDecoration: 'none' }}>
          <Button variant="neutral" size="lg" fullWidth>
            {t('common.back')}
          </Button>
        </Link>
      </div>
    </main>
  );
}

function EnvelopeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M3 7l9 7 9-7" />
    </svg>
  );
}
